import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Wrench } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
// Mock data - singola segnalazione "Oggetto Rotto"
const mockReport = {
  id: 'report-123',
  type: 'Oggetto Rotto',
  emoji: '🔧',
  propertyAddress: 'Via Roma 123, Appartamento 4B',
  area: 'Bagno principale',
  severity: 4,
  timestamp: 'Oggi 10:32',
  isBlocking: true,
  reportedBy: {
    name: 'Mario R.',
    role: 'Fornitore pulizie'
  },
  description: 'Il rubinetto del lavandino perde acqua continuamente. La perdita sembra provenire dalla base del rubinetto.'
};
export function ManutenzioneHomePage() {
  const {
    t
  } = useLanguage();
  const navigate = useNavigate();
  const handleViewDetails = () => {
    navigate(`/manutenzione/reports/${mockReport.id}`);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1459">
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1460">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1461">
          <h1 className="text-4xl font-bold text-navy mb-3" data-id="element-1462">
            {t.manutenzione.dashboard.title}
          </h1>
          <p className="text-base text-gray-600" data-id="element-1463">
            {t.manutenzione.dashboard.subtitle}
          </p>
        </div>

        {/* Property Info */}
        <div className="mb-6" data-id="element-1464">
          <div className="flex items-center gap-3 mb-2" data-id="element-1465">
            <div className="w-12 h-12 rounded-full bg-teal-50 flex items-center justify-center" data-id="element-1466">
              <Wrench className="w-6 h-6 text-teal-deep" data-id="element-1467" />
            </div>
            <div data-id="element-1468">
              <h2 className="text-xl font-bold text-navy" data-id="element-1469">
                {mockReport.propertyAddress}
              </h2>
              <p className="text-base text-gray-500" data-id="element-1470">
                Intervento di manutenzione richiesto
              </p>
            </div>
          </div>
        </div>

        {/* Single Report Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-1471">
          <Card className="p-8 border-2 border-red-200 bg-red-50/30" data-id="element-1472">
            <div className="flex items-start justify-between mb-6" data-id="element-1473">
              <div className="flex items-start gap-4 flex-1" data-id="element-1474">
                <span className="text-5xl" data-id="element-1475">{mockReport.emoji}</span>
                <div className="flex-1" data-id="element-1476">
                  <div className="flex items-center gap-3 mb-2" data-id="element-1477">
                    <h3 className="text-2xl font-bold text-navy" data-id="element-1478">
                      {mockReport.type}
                    </h3>
                    {mockReport.isBlocking && <span className="px-4 py-1.5 bg-red-100 text-red-700 rounded-full text-base font-semibold border border-red-200" data-id="element-1479">
                        Bloccante
                      </span>}
                  </div>
                  <p className="text-lg text-gray-600 mb-1" data-id="element-1480">
                    {mockReport.area}
                  </p>
                  <p className="text-base text-gray-500" data-id="element-1481">
                    Segnalato {mockReport.timestamp}
                  </p>
                </div>
              </div>
            </div>

            {/* Quick Info */}
            <div className="bg-white rounded-xl p-5 mb-6" data-id="element-1482">
              <p className="text-base text-gray-700 leading-relaxed" data-id="element-1483">
                {mockReport.description}
              </p>
            </div>

            {/* CTA Button */}
            <Button onClick={handleViewDetails} className="w-full text-lg h-14" data-id="element-1484">
              Visualizza Dettagli e Inizia Intervento
              <ArrowRight className="w-5 h-5 ml-2" data-id="element-1485" />
            </Button>
          </Card>
        </motion.div>

        {/* Info Note */}
        <div className="mt-6 bg-blue-50 border border-blue-100 rounded-xl p-5" data-id="element-1486">
          <p className="text-base text-blue-900" data-id="element-1487">
            💡 Ricordati di scattare le foto del prima prima di iniziare
            l'intervento
          </p>
        </div>
      </main>
    </div>;
}